module.exports = __webpack_public_path__ + "img/lbnr_detail.ff2bd0c1.png";